import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { dm_suckhoe } from '../../../models/response/category/dm_suckhoe';
import { eSucKhoeActionTypeIds, ISucKhoeActionTypes } from '../../action-types/danh-muc/ISucKhoeActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* sucKhoeSaga(): any {
    yield takeLatest(eSucKhoeActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eSucKhoeActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eSucKhoeActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.sucKhoe.sucKhoe.selectAllView)
    if (res.is_success) {
        yield put(actions.sucKhoe.sucKhoe.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.sucKhoe.sucKhoe.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: ISucKhoeActionTypes): any {
    const payload: dm_suckhoe = action.payload as dm_suckhoe;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.sucKhoe.sucKhoe.update, payload)
    } else {
        res = yield call(apiWrapper.sucKhoe.sucKhoe.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.sucKhoe.sucKhoe.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.sucKhoe.sucKhoe.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: ISucKhoeActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.sucKhoe.sucKhoe.delete, payload)
    if (res.is_success) {
        yield put(actions.sucKhoe.sucKhoe.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.sucKhoe.sucKhoe.DELETE_ERROR(res.message ?? "Error"))
    }
}
